<div class="w-100 h-100">
    <div class="row" style="padding-top: 56px;">
        <div class="col-md-12">
            <div class="form-row justify-content-between align-items-baseline">
                <div class="col-auto">
                    <label class="header_text ur-page-title mb-3">
                        {{$t('shared.updateRequestData')}}
                    </label>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="card card_layout">
                <div class="card-body ur-card-body">
                    <div class="row align-items-end ur-lookup-row">
                        <div class="col-md-3 mb-3">
                            <div class="form-group mb-0">
                                <label class="d-block mb-1">{{$t('shared.customerType')}}</label>
                                <v-select v-model="lookupModel.customerType"
                                          :items="customerTypeList"
                                          :label="$t('shared.select')"
                                          item-text="name"
                                          item-value="id"
                                          solo
                                          hide-details
                                          :disabled="provider.isVirtualOperator">
                                </v-select>
                            </div>
                        </div>
                        <div class="col-md-3 mb-3" v-if="lookupModel.customerType !== 0 && lookupModel.customerType !== 3">
                            <div class="form-group mb-0">
                                <label class="d-block mb-1">{{referenceLabel}}</label>
                                <input class="form-control" v-model="lookupModel.crNumber" type="text" />
                            </div>
                        </div>
                        <div class="col-md-3 mb-3" v-if="lookupModel.customerType === 2 || lookupModel.customerType === 3">
                            <div class="form-group mb-0">
                                <label class="d-block mb-1">{{$t('shared.enterpriseUnifiedNumber')}}</label>
                                <input class="form-control" v-model="lookupModel.enterpriseUnifiedNumber" type="text"
                                       :disabled="provider.isVirtualOperator" />
                            </div>
                        </div>
                        <div class="col-md-auto mb-3" v-if="lookupModel.customerType !== 0">
                            <div class="form-group mb-0">
                                <label class="d-block mb-1">&nbsp;</label>
                                <button class="btn btn-primary ur-action-btn"
                                        @click="apply"
                                        :disabled="!isValidApply">
                                    {{$t('shared.apply')}}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="form-row justify-content-end align-items-center mt-4 mr-2" v-if="!showEntityInfo">
                        <div class="col-auto">
                            <a class="link_danger" @click="cancel">{{$t('shared.back')}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row" v-if="showEntityInfo" style="margin-top: 24px;">
        <div class="col-md-12">
            <div class="card card_layout">
                <div class="card-body ur-card-body">
                    <div class="row">
                        <div class="col-md-12 mb-3">
                            <label class="ur-client-name-label">{{$t('updateDataRequestsPage.clientName')}}</label>
                            <h3 class="ur-client-name-title">{{ entityInfo.clientName }}</h3>
                        </div>
                    </div>
                    <hr class="ur-split-line" />
                    <v-data-table :headers="headers"
                                  :items="senders"
                                  :rows-per-page-text="$t('shared.rowsPerPage')"
                                  :rows-per-page-items="[10, 25, 50, 100]"
                                  item-key="senderId"
                                  class="elevation-1 table-striped">
                        <template v-slot:headers="props">
                            <tr>
                                <th v-for="header in props.headers" :key="header.text" class="text-center">
                                    {{ header.text }}
                                </th>
                            </tr>
                        </template>
                        <template v-slot:items="props">
                            <tr>
                                <td class="text-center">{{ props.item.senderName }}</td>
                                <td class="text-center">
                                    <span v-for="(st, idx) in props.item.senderTypes" :key="idx">
                                        {{ getSenderTypeText(st) }}<span v-if="idx < props.item.senderTypes.length - 1">, </span>
                                    </span>
                                </td>
                                <td class="text-center btn_menu">
                                    <v-btn color="btn-primary" @click="openEdit(props.item)">
                                        <div>
                                            <i class="fas fa-pencil-alt pr-2"></i>{{$t('shared.edit')}}
                                        </div>
                                    </v-btn>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <div class="form-row justify-content-end align-items-center mt-4 mr-2">
                        <div class="col-auto">
                            <a class="link_danger" @click="cancel">{{$t('shared.back')}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <v-dialog v-model="editDialog" width="640" persistent>
        <v-card>
            <v-card-title class="headline grey lighten-2" primary-title>
                {{$t('shared.updateRequestData')}}
                <div class="close__dialog">
                    <i class="fas fa-times" @click="cancelEdit"></i>
                </div>
            </v-card-title>
            <v-card-text class="ur-card-body">
                <v-stepper alt-labels :value="editStep" class="ur-edit-stepper elevation-0 mb-3">
                    <v-stepper-header>
                        <v-stepper-step step="1"
                                        :class="['stepper-label-nowrap', { 'complete': editStep > 1 }]">
                            {{$t('shared.representativeInfo')}}
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step step="2"
                                        :class="['stepper-label-nowrap', { 'complete': editStep > 2 }]">
                            {{$t('shared.reviewRequest')}}
                        </v-stepper-step>
                    </v-stepper-header>
                </v-stepper>
                <div class="row" v-if="editStep === 1">
                    <div class="col-md-12 mb-3">
                        <div class="form-group mb-0">
                            <label>
                                {{$t('shared.representativeName')}}
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon v-bind="attrs" v-on="on"
                                                :style="{ color: 'var(--color-Main)', 'margin-left': '4px' }">
                                            mdi-information-outline
                                        </v-icon>
                                    </template>
                                    <span>{{$t('shared.representativeNameTooltip')}}</span>
                                </v-tooltip>
                            </label>
                            <input class="form-control" v-model="editModel.representativeName" type="text" />
                        </div>
                    </div>
                    <div class="col-md-12 mb-3">
                        <div class="form-group mb-0">
                            <label>
                                {{$t('shared.representativePhoneNumber')}}
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon v-bind="attrs" v-on="on"
                                                :style="{ color: 'var(--color-Main)' }">
                                            mdi-information-outline
                                        </v-icon>
                                    </template>
                                    <span>{{$t('shared.notificationPhone')}}</span>
                                </v-tooltip>
                            </label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text gray">+966</span>
                                </div>
                                <input :class="['form-control border-left-0', { 'is-invalid': representativeMobileError }]"
                                       v-model="editModel.representativeMobile"
                                       @paste="isNumberFieldPaste($event)"
                                       @keypress="isNumberField($event)"
                                       @change="isMobileNumberValid"
                                       maxlength="9"
                                       type="text" />
                            </div>
                            <div v-if="representativeMobileError" class="invalid-feedback d-block">
                                {{ representativeMobileError }}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 mb-3">
                        <div class="form-group mb-0">
                            <label>
                                {{$t('shared.representativeEmail')}}
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon v-bind="attrs" v-on="on"
                                                :style="{ color: 'var(--color-Main)' }">
                                            mdi-information-outline
                                        </v-icon>
                                    </template>
                                    <span>{{$t('shared.notificationEmail')}}</span>
                                </v-tooltip>
                            </label>
                            <input :class="['form-control', { 'is-invalid': representativeEmailError }]"
                                   v-model="editModel.representativeEmail"
                                   type="text" />
                            <div class="invalid-feedback" v-if="representativeEmailError">
                                {{ representativeEmailError }}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 mb-3">
                        <div class="form-group mb-0">
                            <label>{{$t('shared.delegationLetter')}}</label>
                            <input type="file" ref="delegationFile" hidden @change="onFilePicked" />
                            <div class="input-group mb-2">
                                <input class="form-control"
                                       :value="displayedFileName"
                                       :placeholder="$t('shared.addAttachment')"
                                       @click="onPickFile"
                                       readonly
                                       type="text" />
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary" type="button" @click="onPickFile">
                                        <i class="fas fa-paperclip"></i>
                                    </button>
                                </div>
                            </div>
                            <div v-if="existingDelegationLetterAttachmentId && !selectedFileName"
                                 class="ur-attachment-chip" style="max-width: 100%;">
                                <i class="fas fa-file-pdf ur-chip-icon"></i>
                                <span class="ur-chip-name">
                                    {{ existingDelegationLetterFileName || $t('shared.delegationLetter') }}
                                </span>
                                <i class="fas fa-download ur-chip-download"
                                   @click="downloadExistingLetter"></i>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 mb-3">
                        <div class="form-group mb-0">
                            <label>{{$t('shared.comment')}}</label>
                            <textarea class="form-control"
                                      v-model="editModel.providerComment"
                                      rows="2"
                                      :placeholder="$t('updateDataRequestsPage.addCommentsPlaceholder')"></textarea>
                        </div>
                    </div>
                </div>
                <div class="row" v-else>
                    <div class="col-md-12 mb-3">
                        <label class="user_info_header mb-0">{{$t('shared.representativeName')}}</label>
                        <h4 class="user_info_txt">{{ editModel.representativeName }}</h4>
                    </div>
                    <div class="col-md-12 mb-3">
                        <label class="user_info_header mb-0">{{$t('shared.representativePhoneNumber')}}</label>
                        <h4 class="user_info_txt"><span class="pr-3">+966</span>{{ editModel.representativeMobile }}</h4>
                    </div>
                    <div class="col-md-12 mb-3">
                        <label class="user_info_header mb-0">{{$t('shared.representativeEmail')}}</label>
                        <h4 class="user_info_txt">{{ editModel.representativeEmail }}</h4>
                    </div>
                    <div class="col-md-12 mb-3">
                        <label class="user_info_header mb-0">{{$t('shared.delegationLetter')}}</label>
                        <h4 class="user_info_txt">{{ displayedFileName || '-' }}</h4>
                    </div>
                    <div class="col-md-12 mb-3" v-if="editModel.providerComment && editModel.providerComment.trim() !== ''">
                        <label class="user_info_header mb-0">{{$t('shared.comment')}}</label>
                        <h4 class="user_info_txt">{{ editModel.providerComment }}</h4>
                    </div>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <div class="form-row justify-content-end align-items-center w-100 px-3 pb-2" v-if="editStep === 1">
                    <div class="col-auto mx-3">
                        <a class="link_danger" @click="cancelEdit">{{$t('shared.cancel')}}</a>
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-primary ur-action-btn"
                                :disabled="!isEditValid || saveInFlight"
                                @click="goToEditReview">
                            {{$t('shared.next')}}
                        </button>
                    </div>
                </div>
                <div class="form-row justify-content-end align-items-center w-100 px-3 pb-2" v-else>
                    <div class="col-auto mx-3">
                        <a class="link_danger" @click="backToEditStep">{{$t('shared.back')}}</a>
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-primary ur-action-btn"
                                :disabled="!isEditValid || saveInFlight"
                                @click="saveEdit">
                            {{$t('shared.save')}}
                        </button>
                    </div>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
